import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Dispositivo, Empregador, JornadaPonto, Departamento } from '../../api.service';
import { PainelHorariosRelogioComponent } from './painel-horarios-relogio.component';
import { PainelJornadasRelogioComponent } from './painel-jornadas-relogio.component';
import { PainelTerminaisRelogioComponent } from './painel-terminais-relogio.component';
import { SeletorAbaRelogioComponent } from './seletor-aba-relogio.component';
import { ServicoRelogioPonto } from './servico-relogio-ponto';

export type AbaRelogio = 'horarios' | 'jornadas' | 'terminais';

@Component({
  selector: 'app-tela-relogio',
  standalone: true,
  imports: [
    CommonModule,
    PainelHorariosRelogioComponent,
    PainelJornadasRelogioComponent,
    PainelTerminaisRelogioComponent,
    SeletorAbaRelogioComponent
  ],
  templateUrl: './tela-relogio.component.html'
})
export class TelaRelogioComponent {
  @Input() aba: AbaRelogio = 'horarios';
  @Input() empregadores: Empregador[] = [];
  @Input() departamentos: Departamento[] = [];
  @Input() empregadorSelecionado = '';
  @Input({ required: true }) relogioEmpregador!: Empregador;
  @Input({ required: true }) jornada!: JornadaPonto;
  @Input() jornadas: JornadaPonto[] = [];
  @Input({ required: true }) terminal!: Dispositivo;
  @Input() terminais: Dispositivo[] = [];

  @Output() abaChange = new EventEmitter<AbaRelogio>();
  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() alterarEmpregador = new EventEmitter<void>();
  @Output() carregarRelogio = new EventEmitter<void>();
  @Output() carregarJornadas = new EventEmitter<void>();
  @Output() carregarTerminais = new EventEmitter<void>();
  @Output() mensagem = new EventEmitter<string>();
  @Output() terminalChange = new EventEmitter<Dispositivo>();
  @Output() relogioSalvo = new EventEmitter<Empregador>();
  @Output() relogioLimpo = new EventEmitter<Empregador>();
  @Output() jornadaSalva = new EventEmitter<JornadaPonto>();
  @Output() jornadaLimpa = new EventEmitter<JornadaPonto>();
  @Output() jornadaExcluida = new EventEmitter<void>();
  @Output() terminalSalvo = new EventEmitter<Dispositivo>();
  @Output() terminalLimpo = new EventEmitter<Dispositivo>();
  @Output() terminalRevogado = new EventEmitter<Dispositivo>();
  @Output() terminalExcluido = new EventEmitter<void>();

  constructor(private readonly servicoRelogioPonto: ServicoRelogioPonto) {}

  selecionarAba(aba: AbaRelogio) {
    this.abaChange.emit(aba);
    const carregamento = this.servicoRelogioPonto.carregamentoAba(aba);
    if (carregamento === 'relogio') {
      this.carregarRelogio.emit();
    } else if (carregamento === 'jornadas') {
      this.carregarJornadas.emit();
    } else {
      this.carregarTerminais.emit();
    }
  }

}
